import { render, staticRenderFns } from "./RecordPurchaseCollection.vue?vue&type=template&id=36e3cd52&"
import script from "./RecordPurchaseCollection.vue?vue&type=script&lang=js&"
export * from "./RecordPurchaseCollection.vue?vue&type=script&lang=js&"
import style0 from "./RecordPurchaseCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports